module.exports = __webpack_public_path__ + "dff552aa108c97fdf78c46af12b45b71.png";